import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Button } from 'reactstrap';

const LoadError = ({ error = 'An error has occured', retry }, { theme }) => (
  <Alert color="danger" className={theme.textCenter}>
    {error}
    {retry && (
      <div>
        <Button color="warning" onClick={retry} className={theme.mt3}>
          Retry
        </Button>
      </div>
    )}
  </Alert>
);

LoadError.contextTypes = {
  theme: PropTypes.object
};

export default LoadError;



// WEBPACK FOOTER //
// ./src/components/load-error/load-error.js